module.exports = __webpack_public_path__ + "static/media/background.bd9e1c83.jpg";